<template>
    <div class="containContent">
        <div class="classFain">
            <div class="title">
                <span class="font-size18 perTit">
                    <i class="el-icon-place font-weight"></i>
                    公共题库
                </span>
            </div>
            <div class="content">
                <div class="left">
                    <span class="classificationText">科目：</span>
                </div>
                <div class="right">
                    <div class="frist " :class="{'fristActive' : isShowFristStretch}">
                        <div class="itemClass xy-center" v-for="(item,i) in options" :key="i"
                            :class="{'avtie' : fristClassIdActive === item.id }" @click="selectFrist(item)">
                            {{item.name}}
                        </div>
                        <div>
                         <div v-if="isShowFristStretch" class="font-size14 xy-center cursor" :class="{'fristStretch' : isShowFristStretch}" @click="StretchFrist">
                            <i class="el-icon-arrow-down font-size18"> </i>
                        </div>
                        <div v-else class="font-size14 xy-center cursor fristStretch"  @click="packUpFrist">
                            <i class="el-icon-arrow-up font-size18"></i>
                        </div>
                        </div>
                    </div>
                    <div class="second " v-if="optionsTwo.length" :class="{'secondActive' : isShowSecondStretch}">
                        <div class="itemClass xy-center" v-for="(item,i) in optionsTwo" :key="i"
                            :class="{'avtie' : secondClassIdActive === item.id }"
                            @click="selectSecond(item)">
                            {{item.name}}
                        </div>
                         <div v-if="isShowSecondStretch" class="font-size14 xy-center cursor" :class="{'secondStretch' : isShowSecondStretch}" @click="StretchSecond">
                            <i class="el-icon-arrow-down font-size18"> </i>
                        </div>
                        <div v-if="isSecondPackUp" class="font-size14 xy-center cursor" :class="{'secondStretch' : isSecondPackUp}" @click="packUpSecond">
                            <i class="el-icon-arrow-up font-size18"></i>
                        </div>
                    </div>
                    <div class="three" v-if="optionsTwo.length && optionsThree.length" :class="{'threeActive' : isShowStretch}" ref="threeClassFasion">
                        <div class="itemClass xy-center" v-for="(item,i) in optionsThree" :key="i"
                            :class="{'avtie' : threeClassIdActive === item.id }" @click="selectThree(item)">
                            {{item.name}}
                        </div>
                        <div v-if="isShowStretch" class="font-size14 xy-center cursor" :class="{'threeStretch' : isShowStretch}" @click="Stretch">
                            <i class="el-icon-arrow-down font-size18"> </i>
                        </div>
                        <div v-if="isPackUp" class="font-size14 xy-center cursor" :class="{'threeStretch' : isPackUp}" @click="packUp">
                            <i class="el-icon-arrow-up font-size18"></i>
                        </div>
                    </div>
                    <div class="three" v-if="optionsThree.length && optionsFour.length" :class="{'threeActive' : isShowFourStretch}" ref="fourClassFasion">
                        <div class="itemClass xy-center" v-for="(item,i) in optionsFour" :key="i"
                             :class="{'avtie' : fourClassIdActive === item.id }" @click="selectFour(item)">
                            {{item.name}}
                        </div>
                        <div v-if="isShowFourStretch" class="font-size14 xy-center cursor" :class="{'threeStretch' : isShowFourStretch}" @click="StretchFour">
                            <i class="el-icon-arrow-down font-size18"> </i>
                        </div>
                        <div v-if="isShowFourPackUp" class="font-size14 xy-center cursor" :class="{'threeStretch' : isShowFourPackUp}" @click="packUpFour">
                            <i class="el-icon-arrow-up font-size18"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {
//     GetSystemCategoryInfo
// } from "@/api/course";
import { getCommonQlMenu as GetSystemCategoryInfo } from "@/api/new-question-iteration/question-library";
import { treeConvertList } from "@/utils"
export default {
    props: {
        type: {
            type: String,
            default: ""
        },
        homePass: {
            type: String,
            default: ""
        }
    },
    components: {},
    data() {
        return {
            options: [],
            optionsTwo: [],
            optionsThree: [],
            optionsFour: [],
            haveSelected: [],
            // 第一级给个默认classId
            fristClassIdActive: "",
            secondClassIdActive: "",
            threeClassIdActive: "",
            fourClassIdActive: "",
            isShowStretch: false,
            isPackUp: false,
            isShowSecondStretch: false,
            isShowFourStretch: false,
            isShowFourPackUp: false,
            isSecondPackUp: false,
            isShowFristStretch: false
        }
    },
    computed: {
    },
    mounted() {
    },
    watch: {
        homePass() {
            if (this.homePass.includes(",")) {
            } else {
                // 首页跳转对应选择类
                this.sycFindClass(this.options, this.homePass)
            }
        },
        "optionsFour.length": {
            handler(val) {
                this.isShowFourStretch = val > 16;
            }
        },
        "optionsThree.length": {
            handler(val) {
                if (val > 16) {
                    this.isShowStretch = true
                } else {
                    this.isShowStretch = false
                }
            }
        },
        "optionsTwo.length": {
            handler(val) {
                if (val > 8) {
                    this.isShowSecondStretch = true
                } else {
                    this.isShowSecondStretch = false
                }
            }
        }

    },
    created() {
        // 机构题库
        this.GetSystemCategoryInfo()
    },
    methods: {
        Stretch() {
            this.isShowStretch = false
            this.isPackUp = true
        },
        packUp() {
            this.isShowStretch = true
            this.isPackUp = false
        },
        StretchFrist() {
            this.isShowFristStretch = false
        },
        packUpFrist() {
            this.isShowFristStretch = true
        },
        StretchSecond() {
            this.isShowSecondStretch = false
            this.isSecondPackUp = true
        },
        StretchFour() {
            this.isShowFourStretch = false
            this.isShowFourPackUp = true
        },

        packUpSecond() {
            this.isShowSecondStretch = true
            this.isSecondPackUp = false
        },
        packUpFour() {
            this.isShowFourStretch = true
            this.isShowFourPackUp = false
        },
        sycFindClass(arr, id) {
            const list = treeConvertList(arr)
            const selectObj = list.find(item => item.id === id)
            if (selectObj) {
                this.selectFrist(selectObj)
                this.selectSecond(selectObj)
            }
            // arr.forEach(v => {
            //     if (v.id === id) {
            //         this.options.forEach(c => {
            //             if (c.parent === id) {
            //                 this.$nextTick(() => {
            //                     this.selectFrist(c)
            //                     // this.selectSecond(v)
            //                 })
            //             }
            //         })
            //     } else if (v.children && v.children.length) {
            //         this.sycFindClass(v.children, id)
            //     }
            // })
        },
        // 购买页面跳转刷新
        buyCycFindClass(arr, ids) {
            arr.forEach(v => {
                if (v.id === ids[0]) {
                    this.$nextTick(() => {
                        this.selectFrist(v)
                    })
                    if (v.children && v.children.length) {
                        v.children.forEach(c => {
                            if (c.id === ids[1]) {
                                this.$nextTick(() => {
                                    this.selectSecond(c)
                                })

                                if (c.children && c.children.length) {
                                    c.children.forEach(d => {
                                        if (d.id === ids[2]) {
                                            this.$nextTick(() => {
                                                this.selectThree(d)
                                            })
                                        }
                                    })
                                }
                            }
                        })
                    }
                } else if (v.children && v.children.length) {
                    this.sycFindClass(v.children, ids)
                }
            })
        },
        async GetSystemCategoryInfo() {
            try {
                const data = await GetSystemCategoryInfo();
                this.options = data
                console.log(data, "data");
                this.$parent.sortData = data
                this.fristClassIdActive = this.options[0].id
                // 首页跳转定位分类列表
                if (this.$route.query.from === "home") {
                    this.sycFindClass(this.options, this.$route.query.queryId)
                } else if (this.$route.query.from === "buy") {
                    let ids = JSON.parse(this.$route.query.queryId)
                    this.buyCycFindClass(this.options, ids)
                    this.$parent.passClassId = ids[2]
                } else if (this.$route.query.from === "fristColum") {
                    this.options.forEach((v) => {
                        if (v.id === this.$route.query.queryId) {
                            this.selectFrist(v)
                        }
                    })
                } else {
                    if (this.options[0].children.length) {
                        this.optionsTwo = this.options[0].children
                        this.secondClassIdActive = this.optionsTwo[0].id
                    }
                    if (this.optionsTwo.length && this.optionsTwo[0].children.length) {
                        this.optionsThree = this.optionsTwo[0].children
                        this.threeClassIdActive = this.optionsThree[0].id
                    }
                    if (this.optionsThree.length && this.optionsThree[0].children.length) {
                        this.optionsFour = this.optionsThree[0].children
                        this.fourClassIdActive = this.optionsFour[0].id
                    }
                    if (this.fourClassIdActive) {
                        this.$parent.passClassId = this.fourClassIdActive
                    } else if (this.threeClassIdActive) {
                        this.$parent.passClassId = this.threeClassIdActive
                    } else if (this.secondClassIdActive) {
                        this.$parent.passClassId = this.secondClassIdActive
                    } else {
                        this.$parent.passClassId = this.fristClassIdActive
                    }
                }
            } catch (err) {
                this.$toast("获取失败")
            }
        },
        selectFrist(val) {
            this.packUp()
            this.packUpSecond()
            this.fristClassIdActive = val.id
            if (val.children.length) {
                this.optionsTwo = val.children
                this.$forceUpdate()
                this.secondClassIdActive = this.optionsTwo[0].id
                if (this.optionsTwo[0].children.length) {
                    this.optionsThree = this.optionsTwo[0].children
                    this.threeClassIdActive = this.optionsThree[0].id
                    if (this.optionsThree[0].children.length) {
                        this.optionsFour = this.optionsThree[0].children
                        this.fourClassIdActive = this.optionsFour[0].id
                    } else {
                        this.optionsFour = []
                        this.fourClassIdActive = ""
                    }
                } else {
                    this.optionsThree = []
                    this.threeClassIdActive = ""
                    this.optionsFour = []
                    this.fourClassIdActive = ""
                }
            } else {
                this.optionsTwo = []
                this.optionsThree = []
                this.optionsFour = []
                this.secondClassIdActive = ""
                this.threeClassIdActive = ""
                this.fourClassIdActive = ""
            }
            if (this.fourClassIdActive) {
                this.$parent.passClassId = this.fourClassIdActive
            } else if (this.threeClassIdActive) {
                this.$parent.passClassId = this.threeClassIdActive
            } else if (this.secondClassIdActive) {
                this.$parent.passClassId = this.secondClassIdActive
            }
        },
        selectSecond(val) {
            this.packUp()
            this.secondClassIdActive = val.id
            if (val.children.length) {
                this.optionsThree = val.children
                this.threeClassIdActive = this.optionsThree[0].id
                if (this.optionsThree[0].children.length) {
                    this.optionsFour = this.optionsThree[0].children
                    this.fourClassIdActive = this.optionsFour[0].id
                } else {
                    this.optionsFour = []
                    this.fourClassIdActive = ""
                }
            }
            if (this.fourClassIdActive) {
                this.$parent.passClassId = this.fourClassIdActive
            } else if (this.threeClassIdActive) {
                this.$parent.passClassId = this.threeClassIdActive
            } else if (this.secondClassIdActive) {
                this.$parent.passClassId = this.secondClassIdActive
            }
        },
        selectThree(val) {
            this.packUp()
            this.threeClassIdActive = val.id
            console.log(val, "selectThree");
            if (val.children.length) {
                this.optionsFour = val.children
                this.fourClassIdActive = this.optionsFour[0].id
            } else {
                this.optionsFour = []
                this.fourClassIdActive = ""
            }
            if (this.fourClassIdActive) {
                this.$parent.passClassId = this.fourClassIdActive
            } else {
                this.$parent.passClassId = this.threeClassIdActive
            }
        },
        selectFour (val) {
            this.fourClassIdActive = val.id
            this.$parent.passClassId = this.fourClassIdActive
        }

    }
}

</script>

<style scoped lang="less">
    .containContent {
        margin: 0 auto;
        margin-top: 20px;

        .classFain {
            padding: 30px;
            box-sizing: border-box;
            background-color: white;

            .title {
                .perTit {
                    font-weight: bold;
                }
            }

            .content {
                display: flex;
                margin-top: 40px;

                .left {
                    margin-top: 8px;
                    flex-shrink: 0;

                    .classificationText {
                        font-size: 14px;
                        color: #72777F;
                    }
                }

                .right {
                    width: 100%;

                    .itemClass {
                        padding: 0 20px;
                        box-sizing: border-box;
                        cursor: pointer;
                        height: 36px;
                        border-radius: 6px;
                        font-size: 14px;
                        color: #72777F;
                        margin-left: 15px;
                    }

                    .avtie {
                        background-color: #2D98FE;
                        color: #fff;
                    }

                    .frist {
                        display: flex;
                        flex-wrap: wrap;
                        position: relative;
                    }

                    .second {
                        overflow: hidden;
                        width: 100%;
                        margin-top: 20px;
                        background: #F8FAFF;
                        padding: 15px 5px;
                        box-sizing: border-box;
                        display: flex;
                        flex-wrap: wrap;
                         position: relative;
                         background-color: #E5F2FF;
                    }

                    .three {
                        width: 100%;
                        margin-top: 20px;
                        background: #F8FAFF;
                        padding: 15px 5px;
                        box-sizing: border-box;
                        display: flex;
                        flex-wrap: wrap;
                         position: relative;
                         background-color: #E5F2FF;
                    }

                    .fristActive{
                       height: 80px;
                       overflow: hidden;
                    }
                     .fristStretch{
                         width: 50px;
                         height: 30px;
                        background-color: white;
                        color: #256CF4;
                        position: absolute;
                        right: 0px;
                        top: 8px;
                         border-radius: 6px;
                      }
                    .threeActive{
                      height: 90px;
                      overflow: hidden;
                    }
                     .threeStretch{
                         width: 50px;
                         height: 30px;
                        background-color: #E5F2FF;
                        color: #256CF4;
                        position: absolute;
                        right: 0px;
                        top: 8px;
                         border-radius: 6px;
                      }
                  .secondActive{
                      height: 90px;
                      overflow: hidden;
                    }
                     .secondStretch{
                         width: 50px;
                         height: 30px;
                        background-color: #E5F2FF;
                        color: #256CF4;
                        position: absolute;
                        right: 0px;
                        top: 8px;
                         border-radius: 6px;
                      }

                }
            }
        }
    }

</style>
